// InfoPage.jsx
import React, { useState } from "react";
import Divider from "@mui/material/Divider";
import { useCurrentSelectedData } from "../../context/CurrentSelectedDataContext";

const Section = ({ sections, className = "" }) => {
  const [selectedTimeIndex, setSelectedTimeIndex] = useState(null);
  const { currentSelectedData, setCurrentSelectedData } =
    useCurrentSelectedData();

  const renderGroupedSlots = (label, value) => {
    console.log('renderGroupedSlots', {label, value});

    const groups = Array.isArray(value) ? value : null;
    return (
      <div className="flex-1">
        <h6 className="font-semibold text-[#333333] font-neue tracking-[0.035em] mb-1">
          {label}
        </h6>
        {groups && groups.length ? (
          <div className="space-y-2">
            {groups.map(({ dateLabel, slots }, idx) => (
              <div key={`${dateLabel}-${idx}`}>
                {dateLabel && (
                  <p className="text-[#242424] text-[14px] font-semibold font-neue tracking-[0.035em]">
                    {dateLabel}
                  </p>
                )}
                <p className="text-[#595959] text-[14px] font-neue tracking-[0.035em]">
                  {(slots || [])
                    .map((s) => (typeof s === "object" ? s.label : s))
                    .join(", ")}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-[#595959] text-[14px] font-neue tracking-[0.035em]">
            {typeof value === "string" ? value : "--"}
          </p>
        )}
      </div>
    );
  };

  const InfoItem = ({ label, value }) => {
    if (label === "Map Preview:") {
      return (
        <div className="flex-1">
          <h6 className="font-semibold text-[#333333] font-neue tracking-[0.035em] mb-1">
            {label}
          </h6>
          <div className="mt-2">
            <iframe
              src={value}
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-lg"
            ></iframe>
          </div>
        </div>
      );
    }

    if (label === "Attachments:") {
      const attachments = Array.isArray(value) ? value : [];
      if (!attachments.length) {
        return null;
      }
      return (
        <div className="flex-1">
          <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4">
            {attachments.map((item, index) => (
              <div
                key={`${item.value || "attachment"}-${index}`}
                className="border border-[#ECECEC] rounded-xl overflow-hidden"
              >
                {item.image ? (
                  <img
                    src={item.image}
                    alt={item.value || `attachment-${index + 1}`}
                    className="w-full h-40 object-cover"
                    loading="lazy"
                  />
                ) : null}
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (label === "Availability:" || label === "Scheduled Time:") {
      return renderGroupedSlots(label, value);
    }

    if (label === "Select a Time to Complete the Work:") {
      return (
        <div className="flex-1">
          <h6 className="font-semibold text-[#333333] font-neue tracking-[0.035em] mb-1">
            {label}
          </h6>
            <div>
              {value.options?.map((option, index) => (
              <div key={index} className="flex items-center mb-2">
                {value.checkbox && (
                  <input
                    type="checkbox"
                    checked={
                      label === "Select a Time to Complete the Work:"
                        ? selectedTimeIndex === index ||
                        currentSelectedData?.timeSelected ===
                        value.options[index]?.value
                        : false
                    }
                    onChange={(e) => {
                      if (label === "Select a Time to Complete the Work:") {
                        if (e.target.checked) {
                          // Set the selected time index
                          setSelectedTimeIndex(index);
                          // Update currentSelectedData with timeSelected
                          if (currentSelectedData && setCurrentSelectedData) {
                            setCurrentSelectedData({
                              ...currentSelectedData,
                              timeSelected: value.options[index]?.value,
                            });
                          }
                        } else {
                          // Only allow unchecking if this is the currently selected item
                          if (selectedTimeIndex === index) {
                            setSelectedTimeIndex(null);
                            // Clear the selected time frame from currentSelectedData
                            if (currentSelectedData && setCurrentSelectedData) {
                              setCurrentSelectedData({
                                ...currentSelectedData,
                                timeSelected: null,
                              });
                            }
                          }
                        }
                      }
                    }}
                    className="mr-3 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                )}
                <p className="text-[#595959] max-w-[724px] w-full text-[14px] font-neue tracking-[0.035em] font-medium">
                  {option.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      );
    }

    return (
      <div className="flex-1">
        <h6 className="font-semibold text-[#333333] font-neue tracking-[0.035em] mb-1">
          {label}
        </h6>
        <p className="text-[#595959] max-w-[724px] w-full text-[14px] font-neue tracking-[0.035em] font-medium">
          {typeof value === "object" && value !== null
            ? JSON.stringify(value)
            : String(value)}
        </p>
      </div>
    );
  };
  const BudgetPreferencesSection = ({ items }) => {
    console.log(items, "itemsbudss");
    const budgetItem = items.find(
      (i) =>
        i.label === "Estimated Cost:" ||
        i.label === "Original Job Estimate Range:"
    );
    const estimatedCost = budgetItem?.value || "--";
    const budgetLabel = budgetItem?.label || "Estimated Cost:";
    const jobPostDate = items.find((i) => i.label === "Job Post Date:")?.value || "--";
    const availability = items.find((i) => i.label === "Availability:");
    console.log(availability, "availabilitybud");
    const timeToComplete = items.find(
      (i) => i.label === "Select a Time to Complete the Work:"
    )?.value || "--";
    const attachments = items.find((i) => i.label === "Attachments:")?.value;

    return (
      <div className="grid grid-cols-2 gap-6 [&>*:nth-child(n+3)]:col-span-2">
        <InfoItem label={budgetLabel} value={estimatedCost} />
        <InfoItem label="Job Post Date:" value={jobPostDate} />
        {availability && (
          <InfoItem label="Availability:" value={availability.value} />
        )}
        {timeToComplete && (
          <InfoItem
            label="Select a Time to Complete the Work:"
            value={timeToComplete}
          />
        )}
        {/* <InfoItem label="Attachments:" value={attachments} /> */}
      </div>
    );
  };

  return (
    <div className={`p-2 md:px-[20px] px-[10px] flex flex-col ${className}`}>
      {sections.map((section, i) => (
        <React.Fragment key={i}>
          <div className="flex flex-col gap-4">
            {section.title && (
              <h4 className=" font-[500]  text-[#242424]">{section.title}</h4>
            )}
            {section.type === "budgetPreferences" ? (
              <BudgetPreferencesSection items={section.items} />
            ) : (
              <div className="space-y-4">
                {section.items.map((item, i) => (
                  <div key={i}>
                    <InfoItem label={item.label} value={item.value} />
                  </div>
                ))}
              </div>
            )}
          </div>
          {i < sections.length - 1 && <Divider sx={{ margin: "16px 0" }} />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Section;
